// extracted by mini-css-extract-plugin
export default {"inputWrapper":"form_inputWrapper__Sk4lA","imgWrapper":"form_imgWrapper__XEp0B"};